// Premier fichier de tokens partagés du web — jusqu'ici chaque page/composant codait ses
// couleurs en dur (~2000 littéraux hex à travers src/). Volontairement minimal pour l'instant :
// juste l'accent (badges de comptage non-lus — voir Layout.tsx/Notifications.tsx) et la
// transition déjà en usage dans PostCard.tsx (ActionButton), remontée ici pour être partagée
// plutôt que redéclarée.
// Noir plein, plus aucune couleur (ni le bleu #0000FF d'origine, ni le rouge #FF2D55 tenté
// ensuite) — consigne explicite du fondateur, 2026-09-07 : "je ne veux aucune couleur juste le
// noir". Les survols (qui doivent rester visuellement distincts d'un état déjà actif, lui aussi
// noir) utilisent un gris intermédiaire codé directement à l'appel, jamais ce token.
export const ACCENT = "#0a0a0a";
export const TRANSITION_FAST = "background-color .15s ease, color .15s ease, border-color .15s ease";

// Couleur de marque dédiée à FAST (ex-QUICK, renommé — la communauté n'a pas adhéré au nom
// d'origine) — un doré volontairement désaturé/champagne, PAS le jaune-or saturé du premier
// jet : FAST doit rester noir/blanc/gris en dominante, le doré n'est qu'une touche de signature
// (contour fin, petit glyphe), jamais un remplissage. Distincte de ACCENT (touche bleue
// rare/survol), du rouge Real (#FF3B30) et du bleu Vibe (#3B82F6) des anneaux de carte. Fixe
// (pas de variante sombre) : c'est une couleur de fonctionnalité, pas un token de thème
// clair/sombre comme ACCENT n'a pas besoin d'être non plus sur ce web mono-thème.
export const FAST_COLOR = "#C9AD6A";
